import { render, staticRenderFns } from "./CertificationTable.vue?vue&type=template&id=bac5c7cc&"
import script from "./CertificationTable.vue?vue&type=script&lang=js&"
export * from "./CertificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports